import { Component, OnInit, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: 'app-training-details',
    styleUrls: ['./trainingDetails.component.scss'],
    templateUrl: './trainingDetails.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TrainingDetails implements OnInit {
    @Input() trainingDetails: any;

    constructor(){}

    ngOnInit(): void {}
}